import React, { Dispatch, SetStateAction } from "react";
import { ActionHandlerFunction, AdminApprovalGroup } from "@preveil-api";
import { AdminUIActionTypes, Message, MessageHandlerDisplayType, MessageToastTypes, useAppDispatch, useAppSelector } from "src/common";
import { Icon, ToolbarButton, ToolbarWrapper } from "src/components";
import { uiActions } from "src/store";
import { RootState } from "src/store/configureStore";

type AllProps = {
  handleAction: ActionHandlerFunction;
  approval_groups: AdminApprovalGroup[];
  loading: boolean;
  setCopiedApprovalGroup: Dispatch<SetStateAction<AdminApprovalGroup | undefined>>;
};

/* Description: Toolbar for approval groups */
function ToolbarComponent(props: AllProps) {
  const { handleAction, approval_groups, loading, setCopiedApprovalGroup } = props;
  const dispatch = useAppDispatch();
  const selected = useAppSelector((state: RootState) => state.admin.selected);
  const selected_approval_groups = approval_groups.filter((ag) => selected.includes(ag.approval_group_id));

  function handleDelete() {
    handleAction({ actionType: AdminUIActionTypes.Delete });
  }

  /* Description: Confirmation Modal for deleting an approval group. */
  function confirmDelete() {
    const confirmation_dialog = new Message(
      "Are you sure you want to delete the selected approval group(s)?",
      MessageHandlerDisplayType.confirm,
      MessageToastTypes.primary,
      "Delete Approval Group(s)?",
      {
        label: "Yes",
        data: true,
        action: handleDelete,
      },
      { label: "No" },
    );
    dispatch(uiActions.handleSetMessage(confirmation_dialog));
  }

  const count_label = approval_groups.length > 0
    ? `${approval_groups.length} Approval Group${approval_groups.length > 1 ? "s" : ""}`
    : "";

  return (
    <ToolbarWrapper
      paginationInfo={<span className="pagination_info">{count_label}</span>}
      refreshAction={() => handleAction({ actionType: AdminUIActionTypes.Refresh })}
      refreshTooltipContent="Refresh Approval Groups"
      isLoading={loading}
    >
      <ToolbarButton
        onClick={() => handleAction({ actionType: AdminUIActionTypes.SetShow })}
        ariaLabel="Create Approval Group"
        tooltipContent="Create Approval Group">
        <Icon className="ficon-plus" />
      </ToolbarButton>
      <ToolbarButton
        disabled={selected_approval_groups.length !== 1}
        onClick={() => { setCopiedApprovalGroup(selected_approval_groups[0]); handleAction({ actionType: AdminUIActionTypes.SetShow }); }}
        ariaLabel="Copy Approval Group"
        tooltipContent="Copy Approval Group">
        <Icon className="ficon-copy" />
      </ToolbarButton>
      <ToolbarButton
        disabled={selected_approval_groups.length < 1}
        onClick={() => confirmDelete()}
        ariaLabel="Delete Selected"
        tooltipContent="Delete Selected">
        <Icon className="ficon-trash-2" />
      </ToolbarButton>
    </ToolbarWrapper>
  );
}

export default React.memo(ToolbarComponent);
